// Definitions of source_id's that a station can have:
// 0 --> GMA DWD
// 1 --> WMO
// 2 --> virtual stations
// 6 --> GMA customer
// 7 --> AMDA3
// 8 --> METAR

export type PossibleSourceIds = 0 | 1 | 2 | 6 | 7 | 8 | null;

/*TODO: endpoints for this (global search component) & endpoint that smw uses differ in the source_ids that they deliver
   the definition of what the numbers mean are different --> smw endpoints need to be adopted
   (for questions --> timo or sebastian) */
export const possibleSourceIds = {
  0: 'GMA DWD',
  1: 'WMO',
  2: 'virtual station',
  3: '-',
  4: '-',
  5: '-',
  6: 'GMA customer',
  7: 'AMDA3',
  8: 'METAR',
};
